import React, {useState} from "react";
import {getQueryParameter} from "../../../../libraries/util/QueryParameterHelper";

export const LogFile: React.FC = (_) => {
	const [loading, setLoading] = useState(false);
	
	const fileName: string = (
		getQueryParameter("filename") ?? ""
	);
	
	
	const downloadFile = async () => {
		try {
			setLoading(true);
			
			const url = window.URL.createObjectURL(new Blob(["www.google.com"]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			setLoading(false);
		} catch (error) {
			console.error("Error downloading file:", error);
			setLoading(false);
		}
	};
	
	return (
		<div>
			<button onClick={downloadFile} disabled={loading}>
				{loading ? "Downloading..." : "Download File"}
			</button>
		</div>
	);
};

